import reactDom from "react-dom";

import App from "./components/app";

reactDom.render(<App />, document.querySelector("#main"));
